module.exports = __webpack_public_path__ + "img/img-banner-inner.289fb935.jpg";